// mediaManagment/ad_types

import { Media            ,
         initializedMedia } from './types';


export interface AdSpot extends Media
 {
  visible                  : boolean     ,
  title                    : string      ,
  description              : string      ,
  duration                 : string      ,
  imageFile                : string      ,   // Pas forcément la même que thumbnail
  videoFile                : string      ,
  computedDuration         : number      ,
 }

export const initializedAdSpot = (): AdSpot => (
 {
  ...initializedMedia()            ,
  visible                  : false     ,
  title                    : ''      ,
  description              : ''     ,
  duration                 : ''      ,
  imageFile                : ''      ,   // Pas forcément la même que thumbnail
  videoFile                : ''      ,
  computedDuration         : 0      ,
});

